import { postSubmit } from '@ui-seeker/utils'

import { isLoadingCommonFilters } from '@signals'
import { BACKEND_APIS } from '@constants'
import {useToast} from "@hooks";
import  {userDetailsFilters } from "../../@signals";


export default function useUserTableActions() {

    const { showToast } = useToast()

    const deleteRow = rowUpdated => {
        try {
            showToast.confirm("Are you sure you want to delete?", {
                onSubmit: () => {
                    showToast.promise(postSubmit(`${BACKEND_APIS.MANAGEMENT}/customer/user-delete`, rowUpdated).then(res => {
                        isLoadingCommonFilters.value = true
                        userDetailsFilters.value = {}
                    }).catch(e => {
                        showToast.error(e)
                    }), {
                        success: 'User deleted successfully',
                        loading: 'Deleting...',
                    })
                }
            })
        } catch {
            showToast.error()
        }
    }

    const sendCredentials = row => {
        try {
            showToast.confirm(`Are you sure you want to send the credentials to ${row.email}?`, {
                onSubmit: () => {
                    showToast.promise(postSubmit(`${BACKEND_APIS.MANAGEMENT}/customer/user-send-credentials`, {
                        userID: row.userID
                    }).catch(e => {
                        showToast.error(e)
                    }), {
                        success: 'Credentials sent successfully',
                        loading: 'Sending...',
                    })
                }
            })
        } catch {
            showToast.error()
        }
    }

    return {
        deleteRow,
        sendCredentials
    }
}